import { bindActionCreators } from "redux";
import { call, put, take } from "redux-saga/effects";

import * as apiCaller from "./../../api/apiConnectCaller";
import { globalHistory } from "./../../history";

export const GET_CALLS = "GET_CALLS";
export const GET_CALLS_ERROR = "GET_CALLS_ERROR";
export const GET_CALLS_SUCCESS = "GET_CALLS_SUCCESS";

export const MAKE_A_CALL_OUT = "MAKE_A_CALL_OUT";
export const MAKE_A_CALL_OUT_SUCCESS = "MAKE_A_CALL_OUT_SUCCESS";
export const MAKE_A_CALL_OUT_ERROR = "MAKE_A_CALL_OUT_ERROR";

export const DISCONNECT_CALL = "DISCONNECT_CALL";
export const DISCONNECT_CALL_SUCCESS = "DISCONNECT_CALL_SUCCESS";
export const DISCONNECT_CALL_ERROR = "DISCONNECT_CALL_ERROR";

export const CALL_SPY = "CALL_SPY";
export const CALL_SPY_SUCCESS = "CALL_SPY_SUCCESS";
export const CALL_SPY_ERROR = "CALL_SPY_ERROR";

/**
 * Reducer
 */

const initialState = {
  calls: [],
  call: {},
  error: false,
  loading: false,
};

export const callsReducer = (state = initialState, action) => {
  // if (!process.env.NODE_ENV || process.env.NODE_ENV === 'development') {
  //     console.log(action)
  // }
  switch (action.type) {
    case GET_CALLS:
      return {
        ...state,
      };
    case GET_CALLS_SUCCESS:
      return {
        ...state,
        calls: action.payload.data,
        error: false,
      };
    case GET_CALLS_ERROR:
      return {
        ...state,
        error: action.error,
      };

    case MAKE_A_CALL_OUT:
      return {
        ...state,
        loading: true,
        call: {},
      };

    case MAKE_A_CALL_OUT_SUCCESS: {
      const newData = state.calls.items.map((b) => {
        if (b.id == action.data.id) {
          b = action.data;
        }
        return b;
      });
      return {
        ...state,
        newData,
        loading: false,
      };
    }

    case MAKE_A_CALL_OUT_ERROR:
      return {
        ...state,
        error: action.error,
        loading: false,
      };

    case DISCONNECT_CALL:
      return {
        ...state,
      };

    case DISCONNECT_CALL_SUCCESS: {
      const newCall = state.calls.items.filter((i) => i.id !== action.data.id);
      return {
        ...state,
        newCall,
      };
    }

    case DISCONNECT_CALL_ERROR:
      return {
        ...state,
        error: action.error,
      };

    default:
      return state;
  }
};

/**
 * Action
 */

export const getCalls = () => ({
  type: GET_CALLS,
});

export const makeACallOut = (type, caller, callee) => ({
  type: MAKE_A_CALL_OUT,
  data: {
    type,
    caller,
    callee,
  },
});

export const disconnectCall = (uuid) => ({
  type: DISCONNECT_CALL,
  data: {
    uuid,
  },
});

export const callSpy = (uuid, originCallee) => ({
  type: CALL_SPY,
  data: {
    uuid,
    originCallee,
  },
});

export const mapActionsCallToProps = (dispatch) => {
  return bindActionCreators(
    {
      getCalls: getCalls,
      makeACallOut,
      disconnectCall,
      callSpy,
    },
    dispatch
  );
};

/**
 * Apis
 */

const getCallsApi = () => {
  return apiCaller.get(`${process.env.REACT_APP_API_CONNECT}/calls`);
};

const makeACallOutApi = (type, caller, callee) => {
  return apiCaller.post(`${process.env.REACT_APP_API_CONNECT}/calls`, {
    type,
    caller,
    callee,
  });
};

const disconnectCallApi = (uuid) => {
  return apiCaller.del(`${process.env.REACT_APP_API_CONNECT}/calls/${uuid}`);
};

const callSpyApi = (uuid, originCallee) => {
  return apiCaller.put(`${process.env.REACT_APP_API_CONNECT}/calls/spy`, {
    uuid,
    originCallee,
  });
};
/**
 * sagas
 */

export const getCallsFlow = function* () {
  while (true) {
    yield take(GET_CALLS);
    try {
      const res = yield call(getCallsApi);
      yield put({
        type: GET_CALLS_SUCCESS,
        payload: {
          ...res.data,
        },
      });
    } catch (error) {
      yield put({ type: GET_CALLS_ERROR, error });
    }
  }
};

export const makeACallOutFlow = function* () {
  while (true) {
    const action = yield take(MAKE_A_CALL_OUT);
    try {
      const res = yield call(
        makeACallOutApi,
        action.data.type,
        action.data.caller,
        action.data.callee
      );
      yield put({
        type: MAKE_A_CALL_OUT_SUCCESS,
        payload: {
          ...res.data,
        },
        data: action.data,
      });
      const history = globalHistory();
      history.push("/calls");
    } catch (error) {
      yield put({ type: MAKE_A_CALL_OUT_ERROR, error });
    }
  }
};

export const disconnectCallFlow = function* () {
  while (true) {
    const action = yield take(DISCONNECT_CALL);
    try {
      const res = yield call(disconnectCallApi, action.data.uuid);
      yield put({
        type: DISCONNECT_CALL_SUCCESS,
        payload: {
          ...res.data,
        },
        data: action.data,
      });
    } catch (error) {
      yield put({ type: DISCONNECT_CALL_ERROR, error });
    }
  }
};

export const callSpyFlow = function* () {
  while (true) {
    const action = yield take(CALL_SPY);
    try {
      const res = yield call(
        callSpyApi,
        action.data.uuid,
        action.data.originCallee
      );
      yield put({
        type: CALL_SPY_SUCCESS,
        payload: {
          ...res.data,
        },
        data: action.data,
      });
    } catch (error) {
      yield put({ type: CALL_SPY_ERROR, error });
    }
  }
};
